import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withStyles } from "@material-ui/core";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";

import {STL_Column} from './STL_Column';
import {CT_Column} from './CT_Column';

//-----------------------------------------------------------------



const useStyles = (theme) => ({

    container: {
        height: '500',
    },

    item: {
        width: '30%',
        height: '500',
        padding: 24
    },

    divider: {
        height: '100vh',
        width: 1,
        backgroundColor: '#c5cae9'
    },

});



//-----------------------------------------------------------------



class TestView_ extends Component {
    
  constructor(props) {
    super(props);

    this.state = {
        showAlertSimulationStart: false,
    };

  }


  render() {

    const {classes} = this.props;


    
    return (

        <Grid //Grid for "New Simulation" Page: Displays STL and CT Columns side by side from their respective files (Desktop version)
            container
            direction="row"
            spacing={1}
            alignItems="stretch"
            justifyContent="flex-start"
            height="100vh"
        >

            <Grid item xs={4} md={4}>

                <STL_Column/>

            </Grid>

            <Divider orientation="vertical" flexItem/>

            <Grid item xs sx={{display: "flex", flexDirection: "row"}}>

              <CT_Column/>

            </Grid>

        </Grid>

    );

  }

}



//-----------------------------------------------------------------



const mapStateToProps = (state, props) => {

  return {
  };

}

const mapDispatchToProps = (dispatch, props) => {

  return {
  };
  
}


const TestView = connect(mapStateToProps, mapDispatchToProps)(TestView_)
export default withStyles(useStyles) (TestView);
